// extracted by mini-css-extract-plugin
export default {"modalTabWrapper":"TextLocalesTab_modalTabWrapper__2oYNG","textTabEditor":"TextLocalesTab_textTabEditor__WkCPJ"};